<template>
  <section>
    <UnifiedFilterSearch
      :filterList="filterList"
      isNotOpenStackeholderSearch
      :itensFilter="getItemsFilter"
      showAutomaticProcessing
      bookmarkType="draft_bookmarks"
      :tabPersistName="tabPersistName"
      @search-value="getSearchValue"
      @filters="getFilterList"
    />
    <div class="level">
      <div class="level-left has-text-left">
        <span class="has-text-weight-semibold">
          {{ getPaginationDetails }}
        </span>
      </div>
      <div class="level-right">
        <div v-if="!isValidSelection" class="buttons">
          <b-button
            :type="isContrast ? 'is-white-dark' : 'is-primary'"
            role="button"
            @click="confirmDelete()"
          >
            <span>
              {{ General.DELETE }}
            </span>
          </b-button>
        </div>
      </div>
    </div>

    <div v-if="observerPage" class="middle">
      <b-table
        class="custom-table-process-panel custom-5-columns-drafts"
        :data="isLoading || dataTable.count === 0 ? [] : dataTable.list"
        :checkedRows.sync="documentsSelectedDraft"
        :sortIcon="sortIcon"
        :sortIconSize="sortIconSize"
        :defaultSort="sortOrder"
        defaultSortDirection="asc"
        backendSorting
        :checkable="!isMobile"
        hoverable
        role="table"
        :loading="isLoading"
        @sort="onSort"
      >
        <template>
          <b-table-column v-slot="props">
            <div class="process-icons">
              <b-tooltip
                v-if="isConfidential(props.row)"
                :type="isContrast ? 'is-white' : 'is-blue-oil'"
                :position="isMobile ? 'is-right' : 'is-top'"
                :label="secrecyName(props.row)"
                role="tooltip"
              >
                <div class="circle-red">
                  <b-icon
                    type="is-white"
                    icon="lock"
                    customSize="mdi-inherit"
                  />
                </div>
              </b-tooltip>
              <b-tooltip
                v-if="subjectIcons[props.row.priority.type]"
                :label="props.row.priority.name"
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                :position="isMobile ? 'is-left' : 'is-top'"
              >
                <b-icon
                  class="custom-flex-item"
                  :icon="subjectIcons[props.row.priority.type].icon"
                  :type="subjectIcons[props.row.priority.type].color"
                />
              </b-tooltip>
              <b-tooltip
                v-if="props.row.automatic_processing"
                :type="isContrast ? 'is-white' : 'is-blue-oil'"
                :position="isMobile ? 'is-left' : 'is-top'"
                :label="General.TEXTS.AUTOMATIC_PROCESSING_SECOND"
                role="tooltip"
              >
                <b-icon type="is-warning" icon="folder-arrow-left-right" />
              </b-tooltip>
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            class="is-narrow cursor-pointer"
            field="date"
            :label="General.DATE"
            :sortable="!isMobile"
            :visible="!isMobile"
          >
            <div
              class="has-text-color-8 "
              @click.stop="editDraft(props.row.id)"
            >
              {{ new Date(props.row.date) | dateFormat("DD/MM/YYYY") }}
            </div>
            <div class="has-text-color-8">
              {{ getReceivedDifferenceDate(props.row.date) }}
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            class="cursor-pointer"
            field="subject"
            :label="General.SUBJECT"
            :sortable="!isMobile"
          >
            <div class="has-text-left" @click.stop="editDraft(props.row.id)">
              <div
                v-if="props.row.subject"
                class="has-text-color-8 has-text-weight-semibold custom-hover"
              >
                {{ props.row.subject || "" }}
              </div>
              <div
                v-else
                class="has-text-color-8 has-text-weight-semibold cursor-pointer-hover"
              >
                {{ General.WITHOUT_SUBJECT.toUpperCase() }}
              </div>
              <div v-if="!isMobile" class="has-text-color-8 ">
                <span class="has-text-weight-semibold-500">
                  {{ General.TO }}:
                </span>
                <b-tooltip
                  :label="
                    props.row.draft_to.length
                      ? `${props.row.draft_to[0].entity.abbreviation}/${
                          props.row.draft_to[0].abbreviation.includes('/')
                            ? props.row.draft_to[0].abbreviation.split('/')[1]
                            : props.row.draft_to[0].abbreviation
                        } - ${props.row.draft_to[0].description}`
                      : ''
                  "
                  :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                  size="is-small"
                >
                  {{
                    props.row.draft_to.length
                      ? `${props.row.draft_to[0].entity.abbreviation}/${
                          props.row.draft_to[0].abbreviation.includes("/")
                            ? props.row.draft_to[0].abbreviation.split("/")[1]
                            : props.row.draft_to[0].abbreviation
                        }`
                      : ""
                  }}{{ props.row.draft_to.length >= 2 ? " e Outros." : "" }}
                </b-tooltip>
              </div>

              <div
                v-if="props.row.bookmark.length && !isMobile"
                class="bookmark-container"
              >
                <b-tag
                  v-for="(tag, index) in props.row.bookmark.length <= 3
                    ? props.row.bookmark
                    : props.row.bookmark.slice(0, 2)"
                  :key="index"
                  rounded
                  :style="
                    `background-color: ${tag.backgroundColor}; color: ${tag.color}`
                  "
                >
                  {{ tag.name }}
                </b-tag>
                <b-tag
                  v-if="props.row.bookmark.length > 3"
                  rounded
                  :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                  >E outros.
                </b-tag>
              </div>
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            class="is-narrow cursor-pointer"
            field="date"
            :label="General.TO"
            :visible="isMobile"
          >
            <div class="has-text-color-8 ">
              <b-tooltip
                :label="
                  props.row.draft_to.length
                    ? `${props.row.draft_to[0].entity.abbreviation}/${
                        props.row.draft_to[0].abbreviation.includes('/')
                          ? props.row.draft_to[0].abbreviation.split('/')[1]
                          : props.row.draft_to[0].abbreviation
                      } - ${props.row.draft_to[0].description}`
                    : ''
                "
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                size="is-small"
                multilined
              >
                {{
                  props.row.draft_to.length
                    ? `${props.row.draft_to[0].entity.abbreviation}/${
                        props.row.draft_to[0].abbreviation.includes("/")
                          ? props.row.draft_to[0].abbreviation.split("/")[1]
                          : props.row.draft_to[0].abbreviation
                      }`
                    : ""
                }}{{ props.row.draft_to.length >= 2 ? " e Outros." : "" }}
              </b-tooltip>
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            class="is-narrow cursor-pointer"
            field="date"
            :label="General.DATE"
            :visible="isMobile"
          >
            <div
              class="has-text-color-8 "
              @click.stop="editDraft(props.row.id)"
            >
              {{ new Date(props.row.date) | dateFormat("DD/MM/YYYY") }}
              {{ getReceivedDifferenceDate(props.row.date) }}
            </div>
          </b-table-column>

          <b-table-column v-slot="props" :visible="isMobile">
            <div v-if="props.row.bookmark.length" class="bookmark-container">
              <b-tag
                v-for="(tag, index) in props.row.bookmark.length <= 3
                  ? props.row.bookmark
                  : props.row.bookmark.slice(0, 2)"
                :key="index"
                rounded
                :style="
                  `background-color: ${tag.backgroundColor}; color: ${tag.color}`
                "
              >
                {{ tag.name }}
              </b-tag>
              <b-tag
                v-if="props.row.bookmark.length > 3"
                rounded
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                >E outros.
              </b-tag>
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            class="is-narrow"
            field="user.last_name"
          >
            <b-tooltip
              :label="General.DELETE"
              :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
              size="is-small"
            >
              <a role="link" @click.stop="confirmDelete(props.row)">
                <b-icon
                  class="spacing-mr-5"
                  :type="isContrast ? 'is-white-dark' : 'is-grey-dark'"
                  icon="delete"
                />
              </a>
            </b-tooltip>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <NoListMessage v-if="!isLoading" />
          </section>
        </template>

        <template v-if="dataTable.count !== 0" slot="footer">
          <div class="table-footer">
            <div class="column is-12 number-page pl-0">
              <span
                class="has-text-black column is-12 pl-0 has-text-weight-normal"
              >
                <b-dropdown
                  v-model="perPage"
                  role="listbox"
                  :expanded="isMobile"
                  position="is-top-right"
                >
                  <template slot="trigger">
                    <b-button
                      class="custom-dropdown-button custom-ph-8"
                      role="button"
                    >
                      <label
                        >{{ perPage }}
                        {{ General.PER_PAGE.toLowerCase() }}</label
                      >

                      <b-icon class="spacing-mx-5" icon="chevron-down" />
                    </b-button>
                  </template>
                  <div class="has-text-color-8 spacing-p-5 has-text-centered">
                    {{ General.RECORDS_FOR_PAGE }}
                    <div class="list-page">
                      <b-dropdown-item
                        v-for="option in optionsPagination"
                        :key="option"
                        :value="option"
                        role="listitem"
                      >
                        <div>
                          {{ option }}
                        </div>
                      </b-dropdown-item>
                    </div>
                  </div>
                </b-dropdown>
              </span>
            </div>
            <div class="columns is-centered">
              <div class="column is-6">
                <b-pagination
                  :total="dataTable.count"
                  :perPage="perPage"
                  :current.sync="currentPage"
                  rangeBefore="1"
                  rangeAfter="1"
                  order="is-centered"
                  class="process-panel-pagination"
                  rounded
                  :iconPrev="prevIcon"
                  :iconNext="nextIcon"
                  role="navigation"
                />
              </div>
            </div>
          </div>
        </template>
        <template v-else slot="footer">
          <div class="columns custom-padding-mt"></div>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import UnifiedFilterSearch from "@/components/UnifiedFilterSearch";
import NoListMessage from "@/components/NoListMessage";
import { App, General } from "@/utils/constants";
import { mapGetters, mapActions } from "vuex";
import {
  PROCESS_PANEL_TABS as TABS,
  PROCESS_STATUS,
  PROCESS_SUBJECT_ICONS as subjectIcons,
  TAB_PERSIST_NAME as PERSIST_NAME
} from "@/utils/enumerate";
import ModalWarning from "@/views/App/ModalWarning.vue";
import { createFilterData } from "@/utils/filters";
import debounce from "lodash/debounce";
import { formatPagination } from "@/utils/transformers";
import { setPersistSort } from "@/plugins/indexDB";

export default {
  name: "ProcessesDrafts",
  components: {
    UnifiedFilterSearch,
    NoListMessage
  },
  data() {
    return {
      App,
      General,
      PROCESS_STATUS,
      subjectIcons,
      sortField: JSON.stringify({ date: "desc" }),
      sortOrder: ["date", "desc"],
      currentPage: 1,
      perPage: 10,
      sortIcon: "menu-up",
      sortIconSize: "is-medium",
      prevIcon: "chevron-left",
      nextIcon: "chevron-right",
      isLoading: true,
      documentsSelectedDraft: [],
      searchValue: "",
      filterList: {},
      ignoreOrderByDefault: false
    };
  },

  computed: {
    ...mapGetters({
      dataTable: "getDraftList",
      optionsPagination: "getItensPage",
      user: "getCurrentUser",
      updateBySockets: "getUpdateBySockets",
      actualTab: "getCurrentTabProcessPanel",
      isConfidentialCheck: "isConfidentialCheck",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),

    getPaginationDetails() {
      return formatPagination(
        this.dataTable,
        this.currentPage,
        this.perPage,
        "SIMPLIFIED"
      );
    },

    isValidSelection() {
      return this.documentsSelectedDraft.length < 2;
    },

    filterData() {
      return createFilterData(this.filterList);
    },

    requestBaseData() {
      return {
        page: this.currentPage,
        search: this.searchValue,
        order_by: this.sortField,
        paginator_count: this.perPage,
        filters: this.filterData,
        ignore_order_by_default: this.ignoreOrderByDefault
      };
    },

    getItemsFilter() {
      return [
        "PROCESS_ORIGIN_CAPACITY",
        "PROCESS_DATE",
        "PROCESS_CCS",
        "PROCESS_BOOKMARKS",
        "PROCESS_ANALYSIS"
      ];
    },
    isCurrentTab() {
      return this.actualTab.value === TABS.DRAFTS.value;
    },
    tabPersistName() {
      return `${PERSIST_NAME.PROCESS_DRAFTS}_${this.user.id}`;
    }
  },

  watch: {
    searchValue() {
      if (this.currentPage === 1) this.getAllDraftData();
      else this.currentPage = 1;
    },

    currentPage() {
      this.getAllDraftData();
    },

    perPage() {
      this.getAllDraftData();
    },

    filterData() {
      if (this.currentPage === 1) this.getAllDraftData();
      else this.currentPage = 1;
    },

    actualTab() {
      this.documentsSelectedDraft = [];
      if (this.isCurrentTab) {
        this.getAllDraftData();
      }
    },

    dataTable: {
      handler() {
        this.documentsSelectedDraft = [];
      }
    },

    updateBySockets: {
      handler(value) {
        if (value === "update_process_draft") {
          if (this.isCurrentTab) this.getAllDraftData();
          this.$store.commit("clearUpdateBySockets");
        }
      }
    }
  },

  async beforeMount() {
    await this.getSortData();
    this.isCurrentTab && this.getAllDraftData(!this.isCurrentTab);
  },

  methods: {
    ...mapActions({
      getSortPersist: "getPersistSortAction",
      draftListRequest: "draftListRequest",
      deleteProcessDraft: "deleteProcessDraft",
      editProcessDraft: "editProcessDraft"
    }),

    getSearchValue(value) {
      this.searchValue = value;
    },

    getFilterList(filterList) {
      this.filterList = filterList;
    },

    getAllDraftData: debounce(async function(only_count = false) {
      this.formatSort(...this.sortOrder);
      this.isLoading = true;
      if (this.observerPage)
        await this.draftListRequest({ ...this.requestBaseData, only_count });
      this.isLoading = false;
    }, 500),

    async editDraft(id) {
      await this.editProcessDraft(id);
    },

    addZero(number) {
      return (number < 10 ? "0" : "") + number;
    },

    getReceivedDifferenceDate(date) {
      const time = new Date(date);
      return `às ${this.addZero(time.getHours())}h ${this.addZero(
        time.getMinutes()
      )}m`;
    },

    confirmDelete(process = null) {
      let processList = [];
      if (process?.id) processList = [{ process_id: process.id }];
      else
        this.documentsSelectedDraft.map(process => {
          processList.push({ process_id: process.id });
        });

      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: this.General.WARNING,
          message: `${this.General.MESSAGES.ARE_YOU_SURE_YOU_WANT_DELETE_DRAFTS}?`,
          confirm: async () => {
            await this.deleteProcessDraft(processList);
            this.getAllDraftData();
          },
          buttons: [
            { label: General.YES, isConfirm: false, action: true },
            { label: General.NO, isConfirm: true, action: false }
          ]
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    async getSortData() {
      this.observerPage = false;
      this.sortOrder = await this.getSortPersist({
        sortField: this.sortField,
        tabPersistName: this.tabPersistName
      });
      this.observerPage = true;
    },

    formatSort(field, order) {
      this.sortField = (order === "desc" ? "-" : "") + field;
      this.ignoreOrderByDefault = true;
    },

    onSort(field, order) {
      this.formatSort(field, order);
      setPersistSort({ name: this.tabPersistName, sort: { [field]: order } });
      this.sortOrder = [field, order];
      this.getAllDraftData();
    },

    secrecyName(process) {
      return process.secrecy.name || "";
    },

    isConfidential(process) {
      return this.isConfidentialCheck(process.secrecy.id);
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";

.custom-padding-mt {
  padding: 50px 0;
}
</style>
